import { useContext } from "react";
import SitePlanContext from "../utils/siteplan-context";
import SETTINGS from "../settings";

import World from "./3d/world";
import { Plane } from "drei";
import Obelisks from "./3d/obelisks";
import BoundaryWall from "./3d/boundaryWall";
import ContourLines from "./3d/contour-lines";
import TerrainWireframe from "./3d/terrain-wireframe";

import log from "loglevel";

const Contours3D = (props) => {
  const sitePlanContext = useContext(SitePlanContext);
  const size = sitePlanContext.heightMap.boundBox.size;

  return (
    <World
      latitude={sitePlanContext.boundBox.north}
      size={Math.max(size.x, size.y)}
      controlData={props.controlData}
    >
      {/* <Plane
        position={[0, -1, 0]}
        receiveShadow
        args={[size.x / 100, size.y / 100]}
        rotation={[Math.PI / 2, 0, 0]}
      >
        <meshLambertMaterial
          attach="material"
          color={0xddffdd}
          side={THREE.DoubleSide}
          // wireframe={true}
        />
      </Plane> */}
      {/* <TerrainWireframe heightMap={sitePlanContext.heightMap} /> */}
      <Obelisks
        heightMap={sitePlanContext.heightMap}
        poiMarkers={sitePlanContext.poiMarkers}
      />
      <BoundaryWall
        heightMap={sitePlanContext.heightMap}
        sitePlanCoords={sitePlanContext.sitePlanCoords}
      />
      <ContourLines terrain={sitePlanContext.heightMap} />
    </World>
  );
};

export default React.memo(Contours3D);
